import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/InvOrders/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/InvOrders/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/InvOrders/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/InvOrders/Save',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/InvOrders/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/InvOrders/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/InvOrders/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}

// 退回
export function Back(keyValue) {
  return request({
    url: '/InvOrders/Back',
    method: 'get',
    params: { keyValue: keyValue }
  });
}

// 关闭
export function Close(data) {
  return request({
    url: '/InvOrders/Close',
    method: 'post',
    data: { paramStr: data }
  });
}
